/* ============================================================
   CHAOS STUDIO — assets/cart-shopify.js  (Shopify version)
   Wraps Shopify Ajax Cart API.
   Import this INSTEAD of cart.js on the Shopify theme.
   ============================================================ */

const ChaosCart = {
  async get() {
    const res = await fetch('/cart.js');
    return res.json();
  },
  async add(variantId, quantity = 1, properties = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties }),
    });
    const data = await res.json();
    await ChaosCart.updateCount();
    return data;
  },
  async update(updates) {
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });
    const data = await res.json();
    await ChaosCart.updateCount();
    return data;
  },
  async remove(variantId) { return ChaosCart.update({ [variantId]: 0 }); },
  async clear() {
    const res = await fetch('/cart/clear.js', { method: 'POST' });
    await ChaosCart.updateCount();
    return res.json();
  },
  async updateCount() {
    try {
      const cart = await ChaosCart.get();
      const count = cart.item_count || 0;
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
        el.classList.toggle('show', count > 0);
      });
      document.querySelectorAll('#cartLabel').forEach(el => {
        el.textContent = count > 0 ? `Cart (${count})` : 'Cart';
      });
    } catch(e) {}
  },
  formatPrice(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0 });
  },
};

document.addEventListener('DOMContentLoaded', () => ChaosCart.updateCount());

window.addToCart = function(product) {
  if (!product.variantId) { console.error('addToCart: no variantId', product); return; }
  const props = {};
  if (product.designUrl)    props['Design Image']  = product.designUrl;
  if (product.prompt)       props['AI Prompt']     = product.prompt;
  if (product.size)         props['Size']          = product.size;
  if (product.color)        props['Color']         = product.color;
  if (product.designSource) props['Design Source'] = product.designSource;
  return ChaosCart.add(product.variantId, 1, props).then(() => {
    const t = document.createElement('div');
    t.className = 'toast toast-success';
    t.innerHTML = '<i class="fas fa-check-circle"></i> Added to cart!';
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 2500);
  });
};

window.ChaosCart = ChaosCart;
